import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  Media: {
    height: '100%',
    width: '100%',
  },

  li: {
    lineHeight: '30px',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    color: 'black',
  },

  mainWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 50px)',
  },

  paperWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '30px',
    width: '100%',
    height: '100%',
  },

  insideH1: {
    marginBottom: 15,
    fontWeight: '300',
    fontSize: '26px',
    lineHeight: '32px',
  },

  insideH4: {
    marginTop: 0,
    marginBottom: 20,
    fontWeight: '300',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },

  connectBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '16px',
    width: '480px',
  },

  connectionBox: {
    height: '80px',
    width: '480px',
    border: 'solid 1px #DBE5DE',
    borderRadius: '8px',
    padding: '16px',
  },

  textBody: {
    fontSize: '16px',
    textAlign: 'center',
    margin: 0,
  },

  textFoot: {
    fontSize: '12px',
    textAlign: 'center',
    margin: '0 0 12px',
  },

  formTitle: {
    marginTop: 20,
    marginBottom: 0,
    width: '100%',
    fontWeight: '400',
    fontSize: '32px',
    lineHeight: '40px',
  },

  formSubTitle: {
    marginTop: 5,
    marginBottom: 0,
    width: '100%',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
  },
}))

export { useStyles }
